// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Reprocessos_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /so/reprocessos/lista/{order_item_id}.
 *
 * Returns the list of reprocesso rows (with joined production_step_name)
 * for the given order item. Wire shape: dados is a list directly.
 *
 * @see So_reprocessos_model::listByOrderItem()
 */
import type { Reprocessos_EnrichedRow } from './Reprocessos_EnrichedRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Reprocessos_ListaResponseDados = Reprocessos_EnrichedRow[];

export type Reprocessos_ListaResponse = ApiResponse<Reprocessos_ListaResponseDados>;

registerResponseContract('Reprocessos_ListaResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      so_reprocesso_id:                 { type: 'number',  required: true },
      so_reprocesso_order_item_id:      { type: 'number',  required: true },
      so_reprocesso_work_order_step_id: { type: 'number',  required: false },
      so_reprocesso_production_step_id: { type: 'number',  required: true },
      so_reprocesso_source:             { type: 'string',  required: true },
      so_reprocesso_photo_before:       { type: 'string',  required: true },
      so_reprocesso_photo_after:        { type: 'string',  required: false },
      so_reprocesso_notes:              { type: 'string',  required: false },
      so_reprocesso_status:             { type: 'string',  required: true },
      so_reprocesso_executed_by:        { type: 'string',  required: true },
      so_reprocesso_completed_at:       { type: 'string',  required: false },
      so_reprocesso_created_at:         { type: 'string',  required: true },
      so_production_step_name:          { type: 'string',  required: false },
    },
  },
})
